<div class="c-header">
    <ng-container *ngIf="!isIframe">
        <div class="c-header__img"></div>
    </ng-container>
    <h2 class="c-header__title">DOCUMENTOS DIGITAIS</h2>
</div>